import { Box, Button, Card, Typography } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { calcPercentage } from './utils';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(5, 2.5),
    textAlign: 'center',
  },
  icon: {
    fontSize: 56,
    color: '#4caf50',
    marginBottom: theme.spacing(2),
  },
  scoreBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover,
  },
  scoreValue: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
}));

export function SuccessStep({ studentName, result, fallbackTotalQuestions, onReset }) {
  const classes = useStyles();
  const totalQuestions = result?.totalQuestions ?? fallbackTotalQuestions;

  return (
    <Card className={classes.card}>
      <CheckCircle className={classes.icon} />
      <Typography variant="h6" gutterBottom>Resultado salvo com sucesso!</Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {studentName}
      </Typography>
      {result?.correctAnswers != null && (
        <Box className={classes.scoreBox}>
          <Typography variant="h4" className={classes.scoreValue}>
            {result.correctAnswers} / {totalQuestions}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {calcPercentage(result.correctAnswers, totalQuestions)}% de acertos
          </Typography>
        </Box>
      )}
      <Box marginTop={3}>
        <Button variant="contained" color="primary" fullWidth onClick={onReset}>
          Corrigir outra avaliação
        </Button>
      </Box>
    </Card>
  );
}
